<template>
    <div class="uh-login">
        <div v-if="formLoading" class="text-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <form v-if="!formLoading" class="form-signin" @submit.prevent="Login">   <!-- // "@submit.prevent" is the shorthand for "v-on:submit.prevent"; ".prevent" avoids a form submit to reload the page -->
            <!-- <img class="mb-4" src="dist/favicon.ico" alt="" height="30"> -->
            <h4 class="mb-3 font-weight-normal text-center">Please sign in</h4>
            <input v-model="input.username" type="email" class="form-control" placeholder="Email address" required autofocus>
            <input v-model="input.password" type="password" class="form-control" placeholder="Password" required>
            <!-- <div class="checkbox mb-3">
                <label>
                <input type="checkbox" value="remember-me"> Remember me
                </label>
            </div> -->
            <p v-if="errMessage != ''" style="color: red;">&#10007; {{ errMessage }}</p>
            <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="!IsValidUmpsEmail">
                Sign in
                <span v-if="formSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </form>
    </div>
</template>

<script>
    import { GetUser, SetUser } from '../token';

    export default {
        data() {
            return {
                reg: /^\b(?!test\b).+@(umpshealth|umps)\.com$/,
                input: {
                    username: "",
                    password: ""
                },
                errMessage: "",
                formLoading: true,
                formSubmitting: false
            }
        },
        mounted() {
            let savedUser = GetUser();
            // console.log("Login GetUser(): ", savedUser);
            if(savedUser == null) {
                this.formLoading = false;
            } else if (Date.now() > Date.parse(savedUser['token timestamp utc']) + (24 * 60 * 60 * 1000)) {
                // console.log(new Date().getTime(), "Date.now():", Date.now());
                // console.log(new Date().getTime(), "token timestamp utc + 24 hours:", Date.now() > Date.parse(savedUser['token timestamp utc']) + (24 * 60 * 60 * 1000));
                this.formLoading = false;
            } else {
                const uri = 'https://uws3pl8bql.execute-api.ap-southeast-2.amazonaws.com/dev/sign-in/token';
                this.$http.post(uri, {
                    "token": savedUser.token
                })
                .then((response) => {
                    // console.log('Respose:', response)
                    // console.log('Status:', response.status)
                    // console.log('Data:', response.data)
                    if (savedUser.ID == response.data.user_id) {
                        let redirectUri = this.$route.query.redirect_uri;
                        // console.log(new Date().getTime(), "redirectUri:", redirectUri);
                        if (redirectUri) {
                            redirectUri = redirectUri.replace("+", "%2B");
                            if (redirectUri.includes("?")) {
                                redirectUri += "&ts=" + new Date().getTime();
                            } else {
                                redirectUri += "?ts=" + new Date().getTime();
                            }
                            this.$router.replace({ path: `/portal?redirect_uri=${redirectUri}` });
                        } else {
                            this.$router.replace({ name: "portal" });
                        }
                    }
                    this.formLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.formLoading = false;
                });
            }
        },
        computed: {
            IsValidUmpsEmail() {
                return this.reg.exec(this.input.username) ? true : false;
            }
        },
        methods: {
            Login() {
                this.formSubmitting = true;

                const uri = 'https://uws3pl8bql.execute-api.ap-southeast-2.amazonaws.com/dev/sign-in';
                this.$http.post(uri, {
                    "email": this.input.username.trim(),
                    "password": this.input.password.trim()
                })
                .then((response) => {
                    // console.log('Respose:', response)
                    // console.log('Status:', response.status)
                    // console.log('Data:', response.data)
                    if (response.data.token) {
                        SetUser(response.data);
                        let redirectUri = this.$route.query.redirect_uri;
                        // console.log(new Date().getTime(), "redirectUri:", redirectUri);
                        if (redirectUri) {
                            redirectUri = redirectUri.replace("+", "%2B");
                            if (redirectUri.includes("?")) {
                                redirectUri += "&ts=" + new Date().getTime();
                            } else {
                                redirectUri += "?ts=" + new Date().getTime();
                            }
                            this.$router.replace({ path: `/portal?redirect_uri=${redirectUri}` });
                        } else {
                            this.$router.replace({ name: "portal" });
                        }
                    } else {
                        this.errMessage = "Incorrect username or password.";
                    }
                    this.formSubmitting = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.formSubmitting = false;
                });
            }
        }
    }
</script>

<style scoped>
    .form-signin {
        width: 100%;
        max-width: 330px;
        padding: 15px;
        margin: auto;
    }
    .form-signin .checkbox {
        font-weight: 400;
    }
    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }
    .form-signin .form-control:focus {
        z-index: 2;
    }
    .form-signin input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
        margin-bottom: 10px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue